import { render, staticRenderFns } from "./TabProducts.vue?vue&type=template&id=81557e42&"
import script from "./TabProducts.vue?vue&type=script&lang=ts&"
export * from "./TabProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports